export default __webpack_public_path__ + "images/767fd9284ca53acf002f825286a3458a-arts-muni.png";